type CounterSettings = {
  initial?: number;
  step?: number;
};

export interface Counter {
  increase(): number;
  decrease(): number;
  valueOf(): number;
  reset(): void;
}

export function createCounter({initial = 0, step = 1}: CounterSettings = {}): Counter {
  let value = initial;

  return {
    increase: () => (value += step),
    decrease: () => (value -= step),
    valueOf: () => value,
    reset: () => {
      value = initial;
    },
  };
}
